<template>
  <router-link
    class="campaign-link-node"
    :to="campaignPath"
    :class="{ 'campaign-link-node--loading': loading }"
  >
    <div class="campaign-link-node__image" v-if="bannerImage">
      <img :src="bannerImage" alt="" />
    </div>
    <div
      class="campaign-link-node__image campaign-link-node__image--placeholder"
      v-else
    >
      <v-icon size="48" color="grey lighten-1">campaigns</v-icon>
    </div>
    <ContentLine
      :text="campaignName"
      icon="campaigns/campaigns"
      icon-tooltip="Campaign"
      tooltip
      :loading="loading"
    />
  </router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CampaignLinkNode',
  props: {
    nodeId: String,
    editMode: Boolean,
    campaignId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('campaigns', ['singleCampaign']),
    campaign() {
      return this.singleCampaign(this.campaignId);
    },
    campaignName() {
      if (!this.campaign) return 'Loading...';
      return (
        this.campaign.internal_name || this.campaign.name || 'Untitled Campaign'
      );
    },
    bannerImage() {
      const bannerImg = this.campaign?.banner_img;
      return bannerImg ? this.minifyFilestackImage(bannerImg) : null;
    },
    campaignPath() {
      return {
        name: 'campaign-edit',
        params: {
          campaignId: this.campaignId,
          type: this.campaign?.default ? 'basic' : 'content',
        },
      };
    },
  },
  watch: {
    campaignId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchCampaignIfNeeded();
        }
      },
    },
  },
  methods: {
    ...mapActions('campaigns', ['loadCampaigns']),
    async fetchCampaignIfNeeded() {
      if (this.campaign || !this.campaignId) return;

      try {
        this.loading = true;
        await this.loadCampaigns();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less">
.campaign-link-node {
  display: block;
  background-color: #fff;
  border-radius: 8px;
  text-decoration: none;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  border: 1px solid whiteSmoke;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &--loading {
    opacity: 0.7;
  }

  &__image {
    width: 100%;
    height: 120px;
    overflow: hidden;
    background-color: var(--v-grey-lighten4);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &--placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .content-line {
    min-height: 48px;
    padding: 8px 12px;
  }

  .content-line__icon .icon-base {
    color: var(--v-primary-base) !important;
  }
}
</style>
